function getCookie(name) {
  if (typeof document === "undefined") return null
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"))
  return match ? match[2] : null
}

/**
 * Fire a Meta conversion event.
 * Sends to both the browser Pixel (client-side) and Meta CAPI (server-side)
 * using the same event_id for deduplication.
 *
 * @param {string} eventName - Meta event name: "Lead", "Contact", "PageView", etc.
 * @param {object} [data]
 * @param {string} [data.email]    - Raw email (hashed server-side before sending to Meta)
 * @param {string} [data.phone]    - Raw phone number (hashed server-side)
 * @param {string} [data.lead_id]  - Meta Lead ID from Lead Ads (15-17 digit string)
 */
export async function fireMetaEvent(eventName, data = {}) {
  if (typeof window === "undefined") return

  const eventId = crypto.randomUUID()

  // 1. Client-side Pixel event (loaded by gatsby-plugin-gdpr-cookies)
  if (window.fbq) {
    window.fbq("track", eventName, {}, { eventID: eventId })
  }

  // 2. Server-side CAPI event via Netlify Function
  try {
    await fetch("/.netlify/functions/meta-event", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_name: eventName,
        event_id: eventId,
        url: window.location.href,
        fbc: getCookie("_fbc"),
        fbp: getCookie("_fbp"),
        email: data.email || null,
        phone: data.phone || null,
        lead_id: data.lead_id || null,
      }),
    })
  } catch (err) {
    console.warn("Meta CAPI event failed:", err)
  }
}
